/* unplugin-vue-components disabled */import script from "./BasePasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./BasePasswordPage.vue?vue&type=style&index=0&id=7719c022&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7719c022"]])

export default __exports__